/**
 * Get the first item that pass the test
 * by second argument function
 *
 * @param {Array} list
 * @param {Function} f
 * @return {*}
 */
export function find(list, f) {
  return list.filter(f)[0]
}

/**
 * Deep copy the given object considering circular structure.
 * This function caches all nested objects and its copies.
 * If it detects circular structure, use cached copy to avoid infinite loop.
 *
 * @param {*} obj
 * @param {Array<Object>} cache
 * @return {*}
 */
export function deepCopy(obj, cache = []) {
  // just return if obj is immutable value
  if (obj === null || typeof obj !== 'object') {
    return obj
  }

  // if obj is hit, it is in circular structure
  const hit = find(cache, c => c.original === obj)
  if (hit) {
    return hit.copy
  }

  const copy = Array.isArray(obj) ? [] : {}
  // put the copy into cache at first
  // because we want to refer it in recursive deepCopy
  cache.push({
    original: obj,
    copy
  })

  Object.keys(obj).forEach(key => {
    copy[key] = deepCopy(obj[key], cache)
  })

  return copy
}

/**
 * forEach for object
 */
export function forEachValue(obj, fn) {
  Object.keys(obj).forEach(key => fn(obj[key], key))
}

export function isObject(obj) {
  return obj !== null && typeof obj === 'object'
}

export function isPromise(val) {
  return val && typeof val.then === 'function'
}

export function assert(condition, msg) {
  if (!condition) throw new Error(`[vuex] ${msg}`)
}

export function partial(fn, arg) {
  return function() {
    return fn(arg)
  }
}

export function ResizeSensor(element, callback) {
  let zIndex = parseInt(getComputedStyle(element))
  if (isNaN(zIndex)) {
    zIndex = 0
  }

  zIndex--

  let expand = document.createElement('div')
  expand.style.position = 'absolute'
  expand.style.left = '0px'
  expand.style.top = '0px'
  expand.style.right = '0px'
  expand.style.bottom = '0px'
  expand.style.overflow = 'hidden'
  expand.style.zIndex = zIndex
  expand.style.visibility = 'hidden'

  let expandChild = document.createElement('div')
  expandChild.style.position = 'absolute'
  expandChild.style.left = '0px'
  expandChild.style.top = '0px'
  expandChild.style.width = '10000000px'
  expandChild.style.height = '10000000px'
  expand.appendChild(expandChild)

  let shrink = document.createElement('div')
  shrink.style.position = 'absolute'
  shrink.style.left = '0px'
  shrink.style.top = '0px'
  shrink.style.right = '0px'
  shrink.style.bottom = '0px'
  shrink.style.overflow = 'hidden'
  shrink.style.zIndex = zIndex
  shrink.style.visibility = 'hidden'

  let shrinkChild = document.createElement('div')
  shrinkChild.style.position = 'absolute'
  shrinkChild.style.left = '0px'
  shrinkChild.style.top = '0px'
  shrinkChild.style.width = '200%'
  shrinkChild.style.height = '200%'
  shrink.appendChild(shrinkChild)

  element.appendChild(expand)
  element.appendChild(shrink)

  function setScroll() {
    expand.scrollLeft = 10000000
    expand.scrollTop = 10000000

    shrink.scrollLeft = 10000000
    shrink.scrollTop = 10000000
  }
  setScroll()

  let size = element.getBoundingClientRect()

  let currentWidth = size.width
  let currentHeight = size.height

  let onScroll = function() {
    let size = element.getBoundingClientRect()

    let newWidth = size.width
    let newHeight = size.height

    if (newWidth != currentWidth || newHeight != currentHeight) {
      currentWidth = newWidth
      currentHeight = newHeight

      callback()
    }

    setScroll()
  }

  expand.addEventListener('scroll', onScroll)
  shrink.addEventListener('scroll', onScroll)
}

if (typeof String.prototype.capitalize !== 'function') {
  String.prototype.capitalize = function(lc, all) {
    if (all) {
      return this.split(' ')
        .map(function(currentValue, index, array) {
          return currentValue.capitalize(lc)
        }, this)
        .join(' ')
        .split('-')
        .map(function(currentValue, index, array) {
          return currentValue.capitalize(false)
        }, this)
        .join('-')
    } else {
      return lc
        ? this.charAt(0).toUpperCase() + this.slice(1).toLowerCase()
        : this.charAt(0).toUpperCase() + this.slice(1)
    }
  }
}

if (!String.prototype.startsWith) {
  String.prototype.startsWith = function(searchString, position) {
    position = position || 0;
    return this.indexOf(searchString, position) === position;
  };
}
